<template>
    <no-layout>
        <div class="mt-24">
            <template>
                <a-result
                    :title="$t('globals.navigation.notifications.not_found.title')"
                    :sub-title="$t('globals.navigation.notifications.not_found.content')"
                >
                    <template #icon>
                        <AlertTwoTone two-tone-color="#5B21B6" />
                    </template>
                    <template #extra>
                        <a-button type="primary" @click="goBack">
                            {{ $t('globals.navigation.notifications.not_found.button') }}
                        </a-button>
                    </template>
                </a-result>
            </template>
        </div>
    </no-layout>
</template>

<script>
import NoLayout from '@/layouts/NoLayout.vue';
import { AlertTwoTone } from '@ant-design/icons-vue';

export default {
    components: {
        NoLayout,
        AlertTwoTone,
    },
    methods: {
        goBack() {
            switch (this.$store.state.user.default_landing_page) {
                case 'claimsvault':
                    this.$router.push({ name: 'home-claims' });
                    break;
                case 'covervault':
                    this.$router.push({ name: 'home-cover' });
                    break;
                case 'claimsvault_dashboard':
                case 'covervault_dashboard':
                    this.$router.push({ name: 'home' });
                    break;
            }
        },
    },
};
</script>
